import React, { useState, useEffect } from 'react';
import * as apiClient from "../../common/apiClient";
import { makeStyles } from '@material-ui/core/styles';
import { Autocomplete } from '@material-ui/lab';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import AssessmentIcon from '@material-ui/icons/Assessment';
import moment from "moment";
import exportFromJSON from 'export-from-json';

import "./report.css";

const useStyles = makeStyles((theme) => ({
    formControl: {
        minWidth: 150,
    },
}));

export const MasterReport3 = (props) => {
    const classes = useStyles({});
    const [cols, setCols] = useState<any>([]);
    const [data, setData] = useState<any>([]);
    const [fetched, setFetched] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [startdate, setStartDate] = useState('');
    const [enddate, setEndDate] = useState('');
    const [hospitals, setHospitals] = useState<any>([]);
    const [hospital, setHospital] = useState<any>([]); 
    const [employees, setEmployees] = useState<any>([]);
    const [employee, setEmployee] = useState(null);
    const [roleTypeId, setRoleTypeId] = useState<any>("");

    useEffect(() => {
        setRoleTypeId(localStorage.getItem("RoleTypeId"));
        getHospitals();
        getEmployees();
    }, []);

    const getHospitals = () => {
        apiClient.getdataWithOrder("hospitals", 'name', 'ASC').then(res => {
            setHospitals(res);
        }).catch(err => console.log(err));
    };

    const getEmployees = () => {
        apiClient.getdataWithOrder("employees", 'name', 'ASC').then(res => {
            setEmployees(res);
        }).catch(err => console.log(err));
    };

    const generateReport = () => {
        setFetched(false);
        let sDate = startdate ? moment(startdate).format('YYYY-MM-DD') : "";
        let eDate = enddate ? moment(enddate).format('YYYY-MM-DD') : "";
        
        
        let hospital_Ids = hospital.length > 0 ? hospital.map((h: any) => h.id).join(',') : "0";

        let requestData = {
            fromDate: sDate,
            toDate: eDate,
            hospitalID: hospital_Ids,
        };

        setLoading(true);

        apiClient.loadReport("/report/invoicereport", requestData)
            .then(res => {
                setData(res);
                if (res.length > 0) {
                    setCols(Object.keys(res[0]));
                }
                setFetched(true);
                setLoading(false);

                if(res && res.length>0)
                            {
                                const fileName = 'download';
                                const exportType = 'xls';
                                exportFromJSON({data:res, fileName, exportType })
                
                            }
                            else
                            {
                                alert("No record found");
                            }
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
            });
    };

    return (
        <div>
            <div className="report-heading">
                 {props.rptTtile}    
            </div>
            
            <div className="filters">
                <div className="filters-input">
                    <div className="start-date">Start Date : <input type="date" value={startdate} onChange={(e) => { setStartDate(e.target.value); }} /></div>
                    <div className="end-date"> End Date : <input type="date" value={enddate} onChange={(e) => { setEndDate(e.target.value); }} /></div>
                    
                    
            </div>

                {roleTypeId !== "5" && (
                    <Autocomplete
                        multiple 
                        options={hospitals}
                        getOptionLabel={(option: any) => option.name}
                        value={hospital} 
                        onChange={(event, newValue) => setHospital(newValue)}
                        renderInput={(params) => <TextField {...params} label="Select Hospital(s)" variant="outlined" />}
                    />
                )}
            </div>

            <div className="filter-action">
                <Button
                    variant="contained"
                    onClick={generateReport}
                    startIcon={<AssessmentIcon />}
                    color="primary"
                >
                    Generate Report
                </Button>
            </div>

            <div className="report-data">
                {isLoading && <CircularProgress />}
                {fetched && data.length > 0 && <div>Total {data.length} Records found</div>}
                {fetched && data.length === 0 && <div>No Record found</div>}
            </div>
        </div>
    );
};
